import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
//import { AppConfiguration } from "../framework/AppConfigProvider";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import FaqPdf from "../assets/documents/Observership_Program_FAQ.pdf";
import AppChecklistPdf from "../assets/documents/Observership_Program_Application_Checklist.pdf";
import OverviewPdf from "../assets/documents/Observership_Program_Overview.pdf";
import CoriPdf from "../assets/documents/CORI_Authorization_Form.pdf";
import GuideToBoston from "../assets/documents/Guide_to_Boston.pdf";
import DressCode from "../assets/documents/VisitorDressCode.pdf";
import Housing from "../assets/documents/Housing_and_Neighborhood_Overview_for_Observers_BCH.pdf";
import Preparing from "../assets/documents/Preparing_for_Your_Observership_at_BCH.pdf";
import EmailImg from "../assets/envelope.svg";
import GlobeImg from "../assets/globe.svg";
import handClap from "../assets/hands-clapping.svg";
import CardListObj from "../components/CardListObj";
import { Applicant_Dashboard_Object } from "../components/ApplicantDashboard";
import webRootContext from "../components/webrootcontext/WebRootContext";
import DataGrid2 from "../framework/DataGrid2";



function ApplicantDashboard() {
	const location = useLocation();
	const userInfo = location.state;
	const history = useHistory();
	//	const localConfig = useContext(AppConfiguration);

	const [applicantDashboardObject, setApplicantDashboardObject] = useState(Applicant_Dashboard_Object);
	const [requirementListData, setRequirementListData] = useState([]);
	const [isInitial, setIsInitial] = useState(true);

	const bchh3 = {
		color: "#c14991",
		fontSize: "20px",
		textAlign: "left",
		lineHeight: "120%",
		fontWeight: "normal",
		fontFamily: "Open Sans"
	};

	const displayText = "Complete";
	const successMsgTitle = "Thank you for completing all of your onboarding requirements!";
	const successMsgContent = <div>
		<div className="padding-bottom-30">You are all set to begin your Observership Program at Boston Children’s Hospital.
			There are no other requirements remaining. The week prior to your start date, the Observership Program Office will be
			in contact with you to provide complete instructions for your first day at the hospital.
		</div>
		<div >If you have any questions in the meantime, please feel free to contact us at <a className="color--boston-ocean" href="mailto:observership.program@childrens.harvard.edu" style={{ "text-transform": "none" }}>Observership.Program@childrens.harvard.edu</a>.
		</div>
	</div>;

	const login_url = webRootContext + "/Login";
	const getDashboard_ApplicantId_api_url = webRootContext + "/rest/dashboard/getApplicantId";
	const getDashboardStatus_api_url = webRootContext + "/rest/dashboard/getStatus";

	const obsLogoImg = "BCH_observershipLogos.png"; //no need to import public folder image file

	const initApplyTitle = "Apply Now";
	const newApplyTitle = "Start New Application";
	const applicationFormUrl = "/observership/ObservershipApplicationForm";

    const lblLetterOfSupport = <b>Letter of Support</b>
    const lblStatementOfPurpose = <b>Statement of Purpose</b>

	const submitApplication = () => {
		history.push({
			pathname: applicationFormUrl,
			state: { data: userInfo === undefined ? null : userInfo.data },
		});
	}

	const updateApplicationDocuments = () => {
		let linkData = {};
		linkData = {...linkData, user : userInfo === undefined ? null : userInfo.data};
		linkData = {...linkData, dashboard : applicantDashboardObject};
		history.push({
			pathname : "/observership/UpdateApplicationDocuments",
			state : { data: linkData},
		});
	};


	function Button1Action(id) {
		// here create the action line with id
		console.log("CardListObj, button clicked, id = ", id);
	}


	function mapDashboardStatusData(data) {
		setApplicantDashboardObject(data);

		let list = data.requirementList;

		let newRequirementsCheckList = list.map(item => {

			let card = {
				id: item.id,
				label: item.label,
				content: item.content,
				contentType: "string",
				contentLink: item.contentLink === "CORI_PDF" ? CoriPdf.toString() : item.contentLink,
				button1Label: item.button1IsDisabled ? "" : item.button1Label,
				button1Style: "button button--primary",
				button1IsDisabled: item.button1IsDisabled,
				button1function: (obj) => {
					if (obj.id === 2 || obj.id === 6) {
						window.open(obj.link, '_blank');
					} else {
						history.push({
							pathname: obj.link,
							state: { data: data.applicantId },
						});
						window.open(obj.link, '_self');
					}
				},
				status: item.status,
				icons: {
					notstarted: webRootContext + "/cardImages/dataRequest_notComplete.svg",
					started: webRootContext + "/cardImages/dataRequest_inProgress.svg",
					completed: webRootContext + "/cardImages/dataRequest_complete.svg"
				}
			};

			return card;

		});

		setRequirementListData(newRequirementsCheckList);
	}

	function populateDashboard() {
		fetch(getDashboard_ApplicantId_api_url, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			mode: "cors"
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				console.log("appInfo object", data);
				getDashboardStatusData(data.applicantId);
			}, (error) => {
				console.log("dashboard error: ", error);
			});

	}

	function getDashboardStatusData(applicantId) {

		if (applicantId === -99) {
			console.log("redirect to login");
			history.push(login_url);
		}

		const url = getDashboardStatus_api_url + "?applicantId=" + applicantId;

		fetch(url, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			mode: "cors"
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				console.log("dashboard applicant:", data);
				mapDashboardStatusData(data);
			}, (error) => {
				console.log("dashboard error: ", error);
			});
	};

	if (isInitial) {
		populateDashboard();

	}

	useEffect(() => {
		setIsInitial(false);
	}, [isInitial]);

	return (
		<>
			<div className="div_2_1_col">
				<div className="div_2_1_col_right">
					<div className="padding-top-30 padding-bottom-30 center_divs">

						<div className="dashboard__alignRight center_divs"><img src={obsLogoImg} alt="observership logo" /></div>
						<div className="dashboard__floatStack">
							<div className={(!applicantDashboardObject.isApplicationCompleted) && applicantDashboardObject.isAccepted ? 'show_div center_divs' : 'hide_div'} style={{ "padding-bottom": 30 }}>
								<div>
									<svg>
										<defs>
											<linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
												<stop offset="30%" stop-color="#41B6E6" />
												<stop offset="40%" stop-color="#628000" />
												<stop offset="30%" stop-color="#628000" />
											</linearGradient>
										</defs>
									</svg>
								</div>
								<div class="circularProgressBarWrapper" style={{ "width": 280, "height": 280, "margin-top": "-130px" }}>

									<CircularProgressbarWithChildren
										value={applicantDashboardObject.completePecent}

										styles={buildStyles({
											// Add the gradient here
											pathColor: `url('#grad1')`,
											trailColor: "#ddd",
											textSize: '10'
										})}
										strokeWidth={6}
									>
										<img class="circularProgressBarImgMargins" src={handClap} alt="handClap" style={{ "padding-bottom": "20px" }} />
										<div style={{ fontSize: 24, marginTop: -5, color: "#003087" }}>
											{`${applicantDashboardObject.completePecent}% ${displayText}`}
										</div>
									</CircularProgressbarWithChildren>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="div_2_1_col_left">
					<div className="div_1_col">
						<div className="horizontal_div padding-top-30 padding-bottom-30">

							<div className="page_title hide_on_mobile margin-left--15">Observership Dashboard</div>
						</div>

						<div className={(!applicantDashboardObject.isApplicationCompleted && (applicantDashboardObject.requestNewStatementPurpose === 1 || applicantDashboardObject.requestNewLetterSupport === 1)) ? "show_div" : "hide_div"}>
							<div className="normal_txt">
								Please update your application by resubmitting your {applicantDashboardObject.requestNewLetterSupport === 1 ? lblLetterOfSupport : ""} {(applicantDashboardObject.requestNewLetterSupport === 1 && applicantDashboardObject.requestNewStatementPurpose === 1) ? " and " : ""} {applicantDashboardObject.requestNewStatementPurpose === 1 ? lblStatementOfPurpose : ""}.
							</div>
							<Button 
								styleName={"button button--special"} 
								id={"updateAppDocs"} 
								onClick={updateApplicationDocuments} 
								text={"UPDATE MY APPLICATION"} />
						</div>

						<div className={!applicantDashboardObject.isAccepted && applicantDashboardObject.completePecent !== 100 && !applicantDashboardObject.isApplicationCompleted ? 'show_div' : 'hide_div'}>
							<div className="normal_txt padding-bottom-30">
								We encourage you to review the <a href={AppChecklistPdf} target="_blank" rel="noopener noreferrer" className="color--boston-ocean" >Application Checklist</a> and
								read our <a href={FaqPdf} target="_blank" rel="noopener noreferrer" className="color--boston-ocean">FAQs</a> carefully before
								beginning your application. Once you have submitted your application, the Observership Program team
								will email you if further information is required. You can also revisit this page to view the latest status of
								your application. Please note that it generally takes six weeks for applications to be reviewed.
							</div>
						</div>

						<div className={applicantDashboardObject.isApplicationCompleted ? "show_div padding-bottom-30 normal_txt" : "hide_div"}>
							Your application process has been completed. To reapply, <a className="color--boston-ocean" href={applicationFormUrl} style={{ "textTransform": "none" }} rel="noopener noreferrer">start a new application</a>.
						</div>

						<div className={applicantDashboardObject.applicationStatus === "" || applicantDashboardObject.isApplicationCompleted ? 'show_div' : 'hide_div'}>
							<Button styleName={"button button--primary"} id={"submitApplication"} onClick={submitApplication} text={applicantDashboardObject.isApplicationCompleted ? newApplyTitle : initApplyTitle} />
						</div>

						<div className={!applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.applicationStatus !== "" && !applicantDashboardObject.isAccepted ? 'show_div' : 'hide_div'}>
							<h2 className="color--boston-blue">Application Checklist</h2>

							<div className="div_1_col datagrid_space--1585 padding-bottom-30 margin-left--30">
								<DataGrid2 data={applicantDashboardObject.applicationChecklist} isDeclined={applicantDashboardObject.isDeclined || (applicantDashboardObject.applicationChecklist.length === 0 || applicantDashboardObject.applicationChecklist[2].status !== "completed")} />
							</div>

						</div>

						<div className={!applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.completePecent === 100 ? 'show_div' : 'hide_div'}>
							<div className="padding-bottom-30" >
								<Ribbon label="Thank you" status="checkmark" subheader={successMsgTitle} content={successMsgContent} />
							</div>

						</div>

						<div className={!applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.isAccepted ? 'show_div' : 'hide_div'}>
							<h2 className="color--boston-blue padding-bottom-30">Onboarding Requirements Checklist</h2>



							<div className="normal_txt padding-bottom-30">
								Congratulations on your acceptance! We look forward to welcoming you to Boston Children’s. Please continue to visit this page to complete
								your onboarding requirements and review your status.
							</div>

							<div className="padding-bottom-30" >
								<CardListObj data={requirementListData} button1Action={(e) => Button1Action(e)} />
							</div>

							<div className="normal_txt padding-bottom-30">
								* Program Fee: Refer to Page 2 of your acceptance package for your invoice number. Once your payment is submitted, it may take up to 7 business days for the status to be updated. If the status does not update, please email the Observership Program.
							</div>

							<div className={requirementListData.length === 6 ? "show_div normal_txt padding-bottom-30" : "hide_div"}>
								**CORI Request: This task requires further verification. Please email the Observership Program with any questions.
							</div>

							<h2 className="color--boston-blue padding-bottom-30">Required Clearances</h2>
							<div className="normal_txt padding-bottom-30">
								The clearances listed below will be initiated by the Observership Program. You will receive further instructions via email. Please note: the earliest that these clearance will be started is 3 months prior to
								your start date. However, we recommend that you begin collecting all your health requirements in preparation.
							</div>

							<div className="datagrid_space--1585 normal_txt padding-bottom-30">
								<DataGrid2 data={applicantDashboardObject.clearanceList} isDeclined={applicantDashboardObject.isDeclined} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="padding-bottom-30">
				<hr className="hr--light" />
			</div>
			<div className="div_1_col padding-left-45">
				<div className="normal_txt padding-bottom-30">
					<div style={bchh3}>Resources</div>
					<div className="version--note">
						<ul>
							{/* Should show when application is submitted but not yet accepted */}
							<li className={!applicantDashboardObject.isAccepted || applicantDashboardObject.applicantId === -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={OverviewPdf} target="_blank" rel="noopener noreferrer">Program Overview</a></li>
							
							{/* Should show when no application submitted OR when application has been accepted */}
							{/* if a previous application was submitted and completed, there will be a valid ID */}
							{/* if no previous applications were submitted, ID defaults to -1 */}
							<li className={applicantDashboardObject.isCompleted || applicantDashboardObject.applicantId === -1 || applicantDashboardObject.isAccepted ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={GuideToBoston} target="_blank" rel="noopener noreferrer">Guide to Boston</a></li>
							
							{/* Should show when no application submitted OR when application submitted but not yet accepted */}
							<li className={!applicantDashboardObject.isAccepted || applicantDashboardObject.isApplicationCompleted || applicantDashboardObject.applicantId === -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={AppChecklistPdf} target="_blank" rel="noopener noreferrer">Application Checklist</a></li>
							
							{/* Should show when application submitted but not yet accepted  */}
							<li className={!applicantDashboardObject.isAccepted || applicantDashboardObject.applicantId === -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={FaqPdf} target="_blank" rel="noopener noreferrer">FAQs</a></li>
							{/* Should show when no application submitted OR when application has been accepted */}
							<li className={applicantDashboardObject.isCompleted || applicantDashboardObject.applicantId === -1 || applicantDashboardObject.isAccepted ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={DressCode} target="_blank" rel="noopener noreferrer">Visitor Dress Code</a></li>
							
							{/* Should only show once application has been accepted and has not been completed */}
							<li className={applicantDashboardObject.isAccepted && !applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.applicantId !== -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={webRootContext + "/BCH_Observership_Program_Occupational_Health_Requirements.pdf"} target="_blank" rel="noopener noreferrer">Immunizations</a></li>
							
							{/* Should only show once application has been accepted and has not been completed */}
							<li className={applicantDashboardObject.isAccepted && !applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.applicantId !== -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={Housing} target="_blank" rel="noopener noreferrer">Housing Guide</a></li>
							
							{/* Should only show once application has been accepted and has not been completed */}
							<li className={applicantDashboardObject.isAccepted && !applicantDashboardObject.isApplicationCompleted && applicantDashboardObject.applicantId !== -1 ? 'show_div' : 'hide_div'}><a className="color--boston-ocean" href={Preparing} target="_blank" rel="noopener noreferrer">Preparing for Your Observership</a></li>
						</ul>
					</div>
				</div>

				<div className="normal_txt padding-bottom-30">
					<div style={bchh3}>Contact Information</div>
					<div>International Health Education</div>
					<div>Observership Program</div>
					<div>300 Longwood Avenue</div>
					<div>Boston, MA 02215</div>
				</div>

				<div id="obsEmailDiv">
					<img src={EmailImg} alt="email" />
					<a href="mailto:observership.program@childrens.harvard.edu" style={{ "text-transform": "none", "word-break": "break-all", "padding-left": "10px" }}>observership.program@childrens.harvard.edu</a>
				</div>

				<div id="obsWebDiv">
					<img src={GlobeImg} alt="website" />
					<a href="https://www.childrenshospital.org/international/health-care-professionals" style={{ "padding-left": "10px" }} target="_blank" rel="noopener noreferrer">Observership Program Website</a>
				</div>

			</div>



		</>

	);
}

export default ApplicantDashboard;